import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { SharedLink } from '../../services/models/shared-link';
import { SocialRoute } from '../../utils/Routes';

export interface StoryTweetsPanelProps {
  sharedLink: SharedLink | undefined;
}

export default function StoryTweetsPanel(props: StoryTweetsPanelProps) {
  const history = useHistory();

  if (!props.sharedLink) {
    return null;
  }

  const story = props.sharedLink.story;

  return (
    <div className="h-full relative flex flex-col">
      <div className="shrink-0">
        <nav className="h-12 border-b border-gray-200 bg-white px-4 flex flex-col justify-center">
          <div className="flex items-center justify-between">
            <h2 className="m-0 text-base font-extrabold text-gray-900">What people are saying</h2>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                onClick={() => history.replace(SocialRoute)}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </nav>
        <div className="lg:hidden border-b border-gray-200 bg-gray-50 px-4 py-2 text-sm font-medium text-gray-800">
          <div className="flex relative">
            <div>
              {/* TODO(Jose): Make use of our StoryCardLink component */}
              <a
                href={story.url}
                className="block focus:outline-hidden hover:no-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4 className="text-base font-extrabold line-clamp-2">{story.title}</h4>
                <p className="mt-1 text-xs font-bold text-gray-500 uppercase">{story.source}</p>
              </a>
            </div>

            {story.imageUrl && (
              <div className="ml-4 shrink-0">
                <img
                  src={story.imageUrl}
                  alt={story.title}
                  width="80"
                  height="80"
                  className="flex-none rounded-lg bg-slate-100 aspect-square"
                  loading="lazy"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div aria-label="Tweet list" className="min-h-0 flex-1 overflow-y-auto">
        <ul className="border-b border-gray-200 divide-y divide-gray-200">
          {props.sharedLink.tweets.map(tweet => (
            <li
              key={tweet.externalStatusId}
              className="relative bg-white p-4 hover:bg-gray-50 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-600"
            >
              <div className="flex justify-between space-x-3">
                <div className="shrink-0">
                  <img className="h-10 w-10 rounded-full" src={tweet.imageUrl} alt="" />
                </div>
                <div className="min-w-0 flex-1">
                  <a
                    href={tweet.externalUrl}
                    className="block focus:outline-hidden hover:no-underline"
                  >
                    <span className="absolute inset-0" aria-hidden="true" />
                    <p className="text-sm font-bold text-gray-900 no-underline truncate ">
                      {tweet.name}
                    </p>
                    <p className="text-sm text-gray-500 no-underline truncate">@{tweet.username}</p>
                  </a>
                </div>
                <time
                  dateTime={tweet.dateCreated?.toString()}
                  className="shrink-0 whitespace-nowrap text-xs text-gray-500"
                ></time>
              </div>
              <div className="mt-2">
                <p className="text-sm text-gray-700">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: tweet.bodyHtml.replace(
                        /href/g,
                        "target='_blank' class='underline' href"
                      ),
                    }}
                  />
                </p>
              </div>
              <div className="mt-2">
                <time
                  dateTime={tweet.dateCreated?.toString()}
                  className="shrink-0 whitespace-nowrap text-xs text-gray-500"
                >
                  {tweet.time}
                </time>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
